import {
  apiGet,
  apiPut,
  apiPost,
  apiPostMultipart,
  apiDelete,
  apiPutMultipart,
} from 'helpers/ApiHelper';

import * as notificationActions from './notificationActions';
import * as landlordApplications from './landlordApplicationsActions';
import * as renewalLeaseWizardActions from './renewalLeaseWizardActions';
import * as leaseDetails from './LeaseDetailsActions';
import * as maintenanceActions from './maintenanceActions';

import {
  toFriendlyDateString,
  toDate,
  onlyNumbers,
  toISO8601DateString,
  objectToQuery,
} from 'helpers/Formatter';

import { destroy, reset } from 'redux-form';
import { browserHistory } from 'react-router';

import moment from 'moment';
import Auth from 'j-toker';
import { featureEnabled } from 'helpers/ToggleBot';

export function sendInvitationOrPassReset(cotenantId) {
  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/landlords/tenants/${cotenantId}/send_invitation_or_pass_reset`
      )
        .done(response => {
          dispatch(notificationActions.showSuccess('emailSuccessfullySent'));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function bypassSignature(cotenantId) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/tenants/${cotenantId}/bypass_signature`)
        .then(response => {
          dispatch(notificationActions.showSuccess('byPassSignatureSuccessfully'));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function openManualRenewalCreator(leaseId) {
  return (dispatch, getState) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/leases/${leaseId}`)
        .then(response => {
          dispatch(openManualRenewalDialog(response.lease_details));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function getLeaseDocuments(leaseId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/leases/${leaseId}/documents`)
        .then(response => {
          dispatch(saveDocuments(response.documents));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function getUnitDocuments(unitId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/units/${unitId}/documents`)
        .then(response => {
          dispatch(saveDocuments(response.documents));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function getPropertyDocuments(propertyId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/properties/${propertyId}/documents`)
        .then(response => {
          dispatch(saveDocuments(response.documents));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function getLeadDocuments(leadId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/leads/${leadId}/documents`)
        .then(response => {
          dispatch(saveDocuments(response.documents));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function saveDocuments(documents) {
  return {
    type: 'LANDLORD_TENANTS::SAVE_DOCUMENTS',
    documents,
  };
}

export function saveUnitId(unitId) {
  return {
    type: 'LANDLORD_TENANTS::SAVE_UNIT_ID',
    unitId,
    shouldShowUnitOptions: true,
  };
}

export function clearUnitOptions() {
  return {
    type: 'LANDLORD_TENANTS::CLEAR_UNIT_OPTIONS',
  };
}

export function saveLeadId(leadDetails, leadNotInvited, leadId) {
  return {
    type: 'LANDLORD_TENANTS::SAVE_LEAD_ID',
    leadId,
    leadNotInvited,
    leadDetails,
    shouldShowLeadOptions: true,
  };
}

function clearLeadId() {
  return {
    type: 'LANDLORD_TENANTS::SAVE_LEAD_ID',
    leadId: null,
    shouldShowLeadOptions: false,
  };
}

export function getCotenantPayments(cotenant_id, should_show) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/cotenant_payments/${cotenant_id}`)
        .done(response => {
          dispatch(showUnitPayments(response.payments));
          dispatch(openPaymentsLedgerDialog(should_show));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

function showUnitPayments(payments) {
  let unitPayments = payments.map(payment => {
    return {
      ...payment,
      date_received: toDate(payment.date_received),
      due_date: toDate(payment.due_date),
    };
  });

  return {
    type: 'LANDLORD_TENANTS::UNIT_PAYMENTS',
    unitPayments,
  };
}

export function openPaymentsLedgerDialog(shouldShow) {
  return {
    type: 'LANDLORD_TENANTS::SHOW_UNIT_PAYMENTS_DIALOG',
    shouldShow,
  };
}

function openManualRenewalDialog(leaseDetails) {
  leaseDetails.lease_end_date = moment(leaseDetails.lease_end_date).add(1, 'day')._d;
  return {
    type: 'LANDLORD_TENANTS::SHOW_MANUAL_RENEWAL_CREATOR',
    shouldShow: true,
    leaseDetails,
  };
}

export function deleteLease(leaseID, cancellationReason) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/leases/cancel/${leaseID}`, {
        cancellation_reason: cancellationReason,
      })
        .done(response => {
          return dispatch(notificationActions.showSuccess('leaseSuccessfullyCancelled'));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function openLeaseNotes() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_LEASE_NOTES_FORM',
    shouldShow: true,
  };
}

export function closeLeaseNotes() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_LEASE_NOTES_FORM',
    shouldShow: false,
  };
}

export function openPrePayments() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_PRE_PAYMENT_FORM',
    shouldShow: true,
  };
}

export function closePrePayments() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_PRE_PAYMENT_FORM',
    shouldShow: false,
  };
}

export function openPaymentPreference() {
  return {
    type: 'LANDLORD_APPLICATIONS::SHOW_PAYMENT_PREFERENCE_MENU',
    shouldShow: true,
  };
}

export function closePaymentPreference() {
  return {
    type: 'LANDLORD_APPLICATIONS::SHOW_PAYMENT_PREFERENCE_MENU',
    shouldShow: false,
  };
}

export function openLeaseDocuments() {
  return {
    type: 'LANDLORD_TENANTS::OPEN_DOCUMENTS',
    shouldShow: true,
    displayMode: 'lease',
  };
}

export function openUnitDocuments() {
  return {
    type: 'LANDLORD_TENANTS::OPEN_DOCUMENTS',
    shouldShow: true,
    displayMode: 'unit',
  };
}

export function openPropertyDocuments(propertyId) {
  return {
    type: 'LANDLORD_TENANTS::OPEN_DOCUMENTS',
    shouldShow: true,
    displayMode: 'property',
    propertyId: propertyId,
  };
}

export function openLeadDocuments() {
  return {
    type: 'LANDLORD_TENANTS::OPEN_DOCUMENTS',
    shouldShow: true,
    displayMode: 'lead',
  };
}

export function closeDocuments() {
  return {
    type: 'LANDLORD_TENANTS::OPEN_DOCUMENTS',
    shouldShow: false,
    displayMode: null,
    propertyId: null,
  };
}

export function getLeaseNotes(lease_id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/lease_notes/${lease_id}`)
        .done(response => {
          dispatch(showLeaseNotes(response.lease_note));
          dispatch(openLeaseNotes());
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function showLeaseNotes(lease_note) {
  return {
    type: 'LANDLORD_TENANTS::LEASE_NOTE',
    lease_note,
  };
}

export function getPrePayments(lease_id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/pre_payments/${lease_id}`)
        .done(response => {
          return dispatch(showPrepayments(response));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function showPrepayments(prePayments) {
  return {
    type: 'LANDLORD_TENANTS::PRE_PAYMENTS',
    prePayments,
  };
}

export function getRentRollStats() {
  const route = '/landlords/rent_roll_stats';
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_RENT_ROLL::FETCH_RENT_ROLL_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'LANDLORD_RENT_ROLL::SAVE_RENT_ROLL_STATS',
          payload: response.detailed_rent_roll_counts,
        });
      }),
    });
  };
}

export function getRentRoll(options = {}) {
  let route = '/landlords/rent_roll';
  if (options) {
    route += objectToQuery(options);
  }
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_RENT_ROLL::FETCH_RENT_ROLL',
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(displayRentRoll(response.rent_roll, Date.now(), options.offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getFilteredRentRoll(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_RENT_ROLL::FETCH_RENT_ROLL',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_rent_roll?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          dispatch(displayRentRoll(response.rent_roll, Date.now(), offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayRentRoll(response, timestamp, offset) {
  return {
    type: 'LANDLORD_RENT_ROLL::SHOW_RENTROLL',
    rentRoll: response,
    timestamp,
    offset,
  };
}

function shouldFreezeTable(shouldFreeze) {
  return {
    type: 'LANDLORD_TENANTS::FREEZE_TABLE',
    shouldFreeze,
  };
}

export function openOptionsMenu(leaseId, applicationId, anchorEl, propertyId) {
  return dispatch => {
    dispatch(shouldFreezeTable(true));
    dispatch(showOptionsMenu(leaseId, anchorEl, true, propertyId));
    dispatch(landlordApplications.saveApplicationId(applicationId));
  };
}

function showOptionsMenu(leaseId, anchorEl, shouldShow, propertyId) {
  return {
    type: 'LANDLORD_TENANTS::SHOW_OPTIONS_MENU',
    leaseId,
    anchorEl,
    shouldShow,
    propertyId,
  };
}

export function goToPage(pageNumber) {
  return {
    type: 'LANDLORD_TENANTS::GO_TO_PAGE',
    pageNumber,
  };
}

export function nextPage() {
  return {
    type: 'LANDLORD_TENANTS::NEXT_PAGE',
  };
}

export function previousPage() {
  return {
    type: 'LANDLORD_TENANTS::PREVIOUS_PAGE',
  };
}

export function closeOptionsMenu(lease_id) {
  return dispatch => {
    dispatch(showOptionsMenu(lease_id, null, false));
    dispatch(shouldFreezeTable(false));
    dispatch(clearLeadId());
    dispatch(clearUnitOptions());
  };
}

export function displayRenewalCreator(leaseDetails, isPreviousLease, isManualRenewal) {
  if (!isPreviousLease) {
    leaseDetails.lease_start_date = toDate(leaseDetails.lease_start_date);
    leaseDetails.lease_end_date = toDate(leaseDetails.lease_end_date);
    leaseDetails.lease_move_in_date = toDate(leaseDetails.lease_move_in_date);
    leaseDetails.early_move_in_date = toDate(leaseDetails.early_move_in_date);
    leaseDetails.effective_date = toDate(leaseDetails.effective_date);
  } else {
    leaseDetails.lease_start_date = moment(toDate(leaseDetails.lease_end_date)).add(1, 'days')._d;
    leaseDetails.monthly_rent = leaseDetails.absolute_renewal_rent;
    leaseDetails.lease_end_date = moment(leaseDetails.lease_start_date)
      .add(1, 'year')
      .subtract(1, 'days')._d;
  }

  leaseDetails.is_in_person_signing = leaseDetails.is_in_person_signing || false;

  if (
    leaseDetails.renters_insurance_required === null ||
    leaseDetails.renters_insurance_required === undefined
  ) {
    leaseDetails.renters_insurance_required = true;
  }

  leaseDetails.is_in_person_signing = leaseDetails.is_in_person_signing || false;
  leaseDetails.allow_year_renewal = leaseDetails.allow_year_renewal || 'true';
  if (leaseDetails.use_n1) {
    leaseDetails.more_than_guideline = leaseDetails.more_than_guideline || 'false';
    leaseDetails.has_been_approved = leaseDetails.has_been_approved || 'false';
  }
  if (!!leaseDetails.rental_incentives) {
    delete leaseDetails.rental_incentives;
  }

  leaseDetails.is_manual_renewal = isManualRenewal;
  return {
    type: 'LANDLORD_TENANTS::SHOW_RENEWAL_CREATOR',
    leaseDetails,
  };
}

export function displayMoveOutCreator(leaseDetails) {
  leaseDetails.lease_end_date = toDate(leaseDetails.lease_end_date);
  leaseDetails.formatted_lease_end_date = toFriendlyDateString(leaseDetails.lease_end_date);

  return {
    type: 'LANDLORD_TENANTS::SHOW_MOVE_OUT_CREATOR',
    leaseDetails,
    pageNumber: 1,
  };
}

export function displayDocumentToSign(documentToSign) {
  return {
    type: 'LANDLORD_TENANTS::DISPLAY_DOCUMENT',
    documentToSign,
  };
}

export function displayLastBillableDay() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_LAST_BILLABLE_DAY',
    shouldShow: true,
  };
}

export function hideLastBillableDay() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_LAST_BILLABLE_DAY',
    shouldShow: false,
  };
}

export function displayN1NextQuestion() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_N1_NEXT_QUESTION',
    shouldShow: true,
  };
}

export function hideN1NextQuestion() {
  return {
    type: 'LANDLORD_TENANTS::SHOW_N1_NEXT_QUESTION',
    shouldShow: false,
  };
}

export function openMoveOutCreator(leaseId) {
  return (dispatch, getState) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/leases/${leaseId}?for_lease_wizard=true`)
        .then(response => {
          if (!response.data) {
            dispatch(displayMoveOutCreator(response.lease_details));
            browserHistory.push('/companies/move_out_creator');
          }
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function openManualLeaseCreator() {
  return (dispatch, getState) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/list_all_properties`)
        .then(response => {
          if (!response.data) {
            dispatch(maintenanceActions.savePropertyList(response));
            browserHistory.push('/companies/manual_lease_creator');
          }
        })
        .catch((error, textStatus) => {
          console.error(textStatus);
        }),
    });
  };
}

export function openRenewalCreator(leaseId, isPreviousLease = false, isManualRenewal = false) {
  return (dispatch, getState) => {
    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() + `/landlords/leases/${leaseId}?for_lease_wizard=true&is_renewal=true`
      )
        .then(response => {
          // clearing previous documents signed
          dispatch(renewalLeaseWizardActions.updateDocumentToSign(null));
          dispatch(displayRenewalCreator(response.lease_details, isPreviousLease, isManualRenewal));
          browserHistory.push('/companies/renewal_creator');
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function putRenewal(data, renewal_id) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  let formData = new FormData();

  data_clone.unit_id = data_clone.unit_selected ? data_clone.unit_selected.value : null;
  data_clone.unit_type_id = data_clone.unit_type_selected
    ? data_clone.unit_type_selected.value
    : null;
  data_clone.property_id = data_clone.property.value;
  data_clone.deposit_amount = onlyNumbers(data_clone.deposit_amount);
  data_clone.key_deposit = onlyNumbers(data_clone.key_deposit);
  data_clone.monthly_parking_fee = onlyNumbers(data_clone.monthly_parking_fee);
  data_clone.monthly_rent = onlyNumbers(data_clone.monthly_rent);
  data_clone.lease_start_date = toISO8601DateString(data_clone.lease_start_date);
  data_clone.lease_end_date = toISO8601DateString(data_clone.lease_end_date);
  data_clone.cotenants = JSON.stringify(data_clone.cotenants);
  data_clone.services_and_utilities = JSON.stringify(data_clone.services_and_utilities);
  data_clone.lease_items = JSON.stringify(data_clone.lease_items);
  data_clone.collect_first_months_with_deposit = JSON.stringify(
    data_clone.collect_first_months_with_deposit
  );
  data_clone.renters_insurance_required = JSON.stringify(data_clone.renters_insurance_required);
  data_clone.create_prorated_charge = JSON.stringify(data_clone.create_prorated_charge);

  if (data_clone.early_move_in_date) {
    data_clone.early_move_in_date = toISO8601DateString(data_clone.early_move_in_date);
  }

  for (let key in data_clone) {
    if (key === 'schedule_a_file' && data[key]) {
      formData.append(key, data[key][0]);
    } else if (data_clone[key] instanceof Object) {
      formData.append(key, JSON.stringify(data_clone[key]));
    } else if (data_clone[key] || data_clone[key] === 0) {
      formData.append(key, data_clone[key]);
    }
  }

  return dispatch => {
    return dispatch({
      payload: apiPutMultipart(
        Auth.getApiUrl() + `/landlords/lease_renewals/${renewal_id}`,
        formData
      )
        .done(response => {
          if (featureEnabled('custom_lease_creator')) {
            return dispatch({
              type: 'LANDLORD_APPLICATIONS::SET_CLAIM_URL',
              payload: response.data.attributes.callback_url,
            });
          }
          hideLoader(dispatch);
          if (response.message === 'not_in_person') {
            browserHistory.push('/companies/rent_roll');
            dispatch(notificationActions.showSuccess('renewalSuccessfullyGenerated'));
          }
          dispatch(displayDocumentToSign(response.table));
          dispatch(goToPage(10));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          hideLoader(dispatch);
          console.error('request failed', error);
        }),
    });
  };
}

export function changePreference(form_data, lease_id) {
  let data_clone = JSON.parse(JSON.stringify(form_data)); // needed so it does not change redux form data
  data_clone.lease_id = lease_id;
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/tenant_payment_preference`, data_clone)
        .done(response => {
          dispatch(notificationActions.showSuccess('paymentPreferenceSuccessfullyUpdated'));
          dispatch(closePaymentPreference());
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function deletePrePayment(prepaymentId) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/pre_payments/${prepaymentId}`)
        .done(response => {
          dispatch(notificationActions.showSuccess('prePaymentSuccessfullyDeleted'));
          dispatch(getPrePayments(response.lease_id));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function reportPrePayment(form_data) {
  let data_clone = JSON.parse(JSON.stringify(form_data)); // needed so it does not change redux form data
  return (dispatch, getState) => {
    data_clone.lease_id = getState().leaseDetails.leaseDetails.id;
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/pre_payments`, data_clone)
        .done(response => {
          dispatch(notificationActions.showSuccess('prePaymentSuccessfullyReported'));
          dispatch(getPrePayments(data_clone.lease_id));
          dispatch(reset('pre_payments_form'));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function saveLeaseNotes(form_data, lease_id) {
  let data_clone = JSON.parse(JSON.stringify(form_data)); // needed so it does not change redux form data
  data_clone.lease_id = lease_id;
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/leases`, data_clone)
        .done(response => {
          dispatch(notificationActions.showSuccess('leaseNoteSuccessfullySaved'));
          dispatch(getRentRoll());
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function postCertificateOfService(renewal_id) {
  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/landlords/lease_renewals/${renewal_id}/certificate_of_services`,
        {}
      )
        .done(response => {
          hideLoader(dispatch);
          dispatch(displayDocumentToSign(response.table));
          dispatch(goToPage(11));
        })
        .catch(error => {
          window.Rollbar.error('Post Certificate Of Service Error', error);
          browserHistory.push('/companies/rent_roll');
          dispatch(notificationActions.showFailure(error));
          hideLoader(dispatch);
          console.error('request failed', error);
        }),
    });
  };
}

export function postRenewalLease(renewal_id, is_in_person_signing) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/lease_renewals/${renewal_id}/leases`, {
        is_in_person_signing,
      })
        .done(response => {
          browserHistory.push('/companies/rent_roll');
          dispatch(notificationActions.showSuccess('successfullyRenewedLease'));
          hideLoader(dispatch);
        })
        .catch(error => {
          browserHistory.push('/companies/rent_roll');
          dispatch(notificationActions.showFailure(error));
          hideLoader(dispatch);
          console.error('request failed', error);
        }),
    });
  };
}

export function putManualLease(data, lease_id) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data

  data_clone.deposit_amount = onlyNumbers(data_clone.deposit_amount);
  data_clone.key_deposit = onlyNumbers(data_clone.key_deposit);
  data_clone.monthly_rent = onlyNumbers(data_clone.monthly_rent);

  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/leases/${lease_id}`, data_clone)
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyUpdatedLease'));
        })
        .catch(error => {
          window.Rollbar.error('Put Manual Lease Error', error);
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function postManualLease(data) {
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  let formData = new FormData();

  data_clone.unit_id = data_clone.unit_selected ? data_clone.unit_selected.value : null;
  data_clone.property_id = data_clone.property.value;
  data_clone.deposit_amount = onlyNumbers(data_clone.deposit_amount);
  data_clone.pet_fee = onlyNumbers(data_clone.pet_fee);
  data_clone.key_deposit = onlyNumbers(data_clone.key_deposit);
  data_clone.monthly_parking_fee = onlyNumbers(data_clone.monthly_parking_fee);
  data_clone.monthly_rent = onlyNumbers(data_clone.monthly_rent);
  data_clone.has_cotenant = data_clone.has_cotenant === 'Yes';
  data_clone.post_dated = data_clone.post_dated === 'Yes';

  for (let key in data_clone) {
    if (key === 'lease_file' && data[key]) {
      formData.append(key, data[key][0]);
    } else if (key === 'cotenants') {
      const cotenants = data_clone[key].map(cotenant => {
        cotenant.birthday = moment(cotenant.dob).toISOString();
        return cotenant;
      });
      formData.append(key, JSON.stringify(cotenants));
    } else if (key === 'lease_items') {
      formData.append(key, JSON.stringify(data_clone[key]));
    } else if (key === 'pets') {
      formData.append(key, JSON.stringify(data_clone[key]));
    } else if (key === 'additional_occupants') {
      formData.append(key, JSON.stringify(data_clone[key]));
    } else if (key === 'emergency_contacts') {
      formData.append(key, JSON.stringify(data_clone[key]));
    } else if (key === 'vehicle_information') {
      formData.append(key, JSON.stringify(data_clone[key]));
    } else if (data_clone[key] || data_clone[key] === 0) {
      formData.append(key, data_clone[key]);
    }
  }

  return dispatch => {
    return dispatch({
      payload: apiPostMultipart(Auth.getApiUrl() + '/landlords/manually_created_leases', formData)
        .done(response => {
          browserHistory.push('/companies/rent_roll');
          dispatch(notificationActions.showSuccess('successfullyCreatedLease'));
          dispatch(destroy('manual_lease_creator_form'));
          hideLoader(dispatch);
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          hideLoader(dispatch);
          console.error('request failed', error);
        }),
    });
  };
}

export function cancelLeaseTermination(leaseId) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/leases/${leaseId}/termination`)
        .done(response => {
          dispatch(notificationActions.showSuccess('moveOutSuccessfullyCancelled'));
        })
        .catch(error => {
          window.Rollbar.error('Lease Cancellation Error', error);
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function postLeaseTermination(data, lease_id) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone.lease_break = data_clone.lease_break === 'Yes';
  if (data_clone.last_billable_day) {
    data_clone.last_billable_day = toISO8601DateString(data_clone.last_billable_day);
  }
  if (data_clone.move_out_date) {
    data_clone.move_out_date = toISO8601DateString(data_clone.move_out_date);
  }

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/leases/${lease_id}/termination`, data_clone)
        .done(response => {
          hideLoader(dispatch);
          return dispatch(notificationActions.showSuccess('leaseSuccessfullyMarkedAsMoveOut'));
        })
        .catch(error => {
          window.Rollbar.error('Post Lease Termination Error', error);
          dispatch(notificationActions.showFailure(error));
          hideLoader(dispatch);
          console.error('request failed', error);
        }),
    });
  };
}

export function inviteLead(lead_id) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/invite_lead/${lead_id}`, {
        lead_id,
      })
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyInvited'));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function optOutLead(lead_id) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/leads/${lead_id}/opt_out`, {
        lead_id,
      }).catch(error => {
        dispatch(notificationActions.showFailure(error));
        throw Error;
      }),
    });
  };
}

export function optInLead(lead_id) {
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/leads/${lead_id}/opt_in`, {
        lead_id,
      }).catch(error => {
        dispatch(notificationActions.showFailure(error));
        throw Error;
      }),
    });
  };
}

export function updateIsInPersonSigning(is_in_person_signing) {
  return {
    type: 'LANDLORD_TENANTS::UPDATE_IS_IN_PERSON_SIGNING',
    is_in_person_signing,
  };
}

export function getTenants(options = {}) {
  // Options: show_all: true will return list of all tenants.
  let route = '/landlords/detailed_tenants';
  if (options) {
    route += objectToQuery(options);
  }
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_TENANTS::FETCH_TENANTS',
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(displayTenants(response.tenants, Date.now(), options.offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getFilteredTenants(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_TENANTS::FETCH_TENANTS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_tenants?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          dispatch(
            displayTenants(
              response.tenants,
              Date.now(),
              offset || 0,
              response.search_total_results_count
            )
          );
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getTenantsStats() {
  const route = '/landlords/tenants_stats';
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_TENANTS::FETCH_TENANTS_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'LANDLORD_TENANTS::SAVE_TENANTS_STATS',
          payload: response.detailed_tenants_counts,
        });
      }),
    });
  };
}

export function getTenant(cotenantID, options) {
  let route = `/landlords/tenants/${cotenantID}`;
  if (options) {
    route += objectToQuery(options);
  }
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(displayTenant(response.tenant));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function getTenantPadDetail(cotenantID) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/cotenants/${cotenantID}/pad_details`)
        .done(response => {
          dispatch({
            type: 'LANDLORD_TENANTS::SHOW_PAD_DETAIL',
            padDetail: response.pad_detail,
          });
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function updateTenantPadDetail(authorizedAmount, payTotalAmount, cotenantID) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/cotenants/${cotenantID}/pad_details`, {
        authorized_amount: authorizedAmount,
        pay_total_amount: payTotalAmount,
      })
        .done(response => {
          return dispatch(notificationActions.showSuccess('landlordPortal.papForm.update.success'));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function deleteTenantPadDetail(cotenantID) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/cotenants/${cotenantID}/pad_details`)
        .done(response => {
          dispatch(
            notificationActions.showSuccess(
              'Successfully deleted Pre-Authorize Payment information.'
            )
          );
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function displayTenant(response) {
  return {
    type: 'LANDLORD_TENANTS::SHOW_TENANT',
    tenantDetails: response,
  };
}

export function displayTenants(response, timestamp, offset, searchTotalResultsCount = null) {
  return {
    type: 'LANDLORD_TENANTS::SHOW_TENANTS',
    tenants: response,
    timestamp,
    offset,
    searchTotalResultsCount,
  };
}

export function displayTenantNotes(response = {}) {
  return {
    type: 'LANDLORD_TENANTS::SHOW_TENANT_NOTES',
    tenantNotes: response.tenant_notes || [],
  };
}

export function toggleDocumentUploaderDialogOpen(documentUploaderDialogOpen) {
  return {
    type: 'LANDLORD_TENANTS::DOCUMENT_UPLOADER',
    documentUploaderDialogOpen,
  };
}

export function getTenantNotes(leadId) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/leads/${leadId}/tenant_notes/`)
        .done(response => {
          dispatch(displayTenantNotes(response));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function submitNote(formData, leadId) {
  let data_clone = JSON.parse(JSON.stringify(formData));
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/leads/${leadId}/tenant_notes/`, data_clone)
        .done(response => {})
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function openTenantsOptionsMenu(
  cotenantId,
  leadId,
  activeLeaseId,
  applicationId,
  anchorEl,
  showInviteTenant
) {
  return {
    type: 'LANDLORD_TENANTS::SHOW_TENANT_OPTIONS_MENU',
    cotenantId,
    leadId,
    activeLeaseId,
    applicationId,
    anchorEl,
    showInviteTenant,
  };
}

export function closeTenantsOptionsMenu() {
  return {
    type: 'LANDLORD_TENANTS::HIDE_TENANT_OPTIONS_MENU',
  };
}

export function clearTenantNotes() {
  return {
    type: 'LANDLORD_TENANTS::CLEAR_TENANT_NOTES',
  };
}

export function deleteCotenant(lease_id, cotenant_id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() + `/landlords/leases/${lease_id}/cotenants/${cotenant_id}`
      )
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyDeletedCotenant'));
          dispatch(leaseDetails.openEditLease(lease_id));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function updateTenantPassword(tenantId, newPassword) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/tenants/${tenantId}/password`, {
        new_password: newPassword,
      })
        .done(response => {
          return dispatch(
            notificationActions.showSuccess('landlordPortal.tenantUpdatePassword.success')
          );
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function deleteAdditionalOccupant(lease_id, occupant_id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() + `/landlords/leases/${lease_id}/additional_occupants/${occupant_id}`
      )
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyDeletedOccupant'));
          dispatch(leaseDetails.openEditLease(lease_id));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

const hideLoader = dispatch => {
  setTimeout(() => {
    dispatch(notificationActions.hideLoader());
  }, 1000);
};

export function triggerRenewal(leaseId, isPreviousLease, isManualRenewal = false) {
  return (dispatch, getState) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/leases/${leaseId}/trigger_renewal`)
        .then(response => {
          dispatch(openRenewalCreator(leaseId, isPreviousLease, isManualRenewal));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function createDocument(data, leaseId) {
  return dispatch => {
    // upload new tenant document
    const multiPartFormData = new FormData();
    multiPartFormData.append('file', data.new_document.file[0]);
    const document_sub_type =
      data.new_document.document_sub_type || data.new_document.document_sub_type_name;
    if (document_sub_type) {
      multiPartFormData.append('document_sub_type', document_sub_type);
    }

    return dispatch({
      payload: apiPostMultipart(
        Auth.getApiUrl() + `/landlords/leases/${leaseId}/documents`,
        multiPartFormData
      )
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyUploadedDocument'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function deleteLeaseDocument(leaseId, documentId) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/landlords/leases/${leaseId}/documents/${documentId}`)
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyDeletedDocument'));
        })
        .catch(error => {
          console.error('request failed', error);
          dispatch(notificationActions.showFailure(error));
        }),
    });
  };
}

export function createLeaseCharge(formData, leaseId) {
  formData.lease_items.forEach(leaseItem => {
    leaseItem.start_date = toISO8601DateString(leaseItem.start_date);
  });

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/leases/${leaseId}/lease_charges`, formData)
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyAddedItem'));
        })
        .catch(error => {
          dispatch(notificationActions.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function showCreateRenewalSuccess() {
  return dispatch => {
    browserHistory.push('/companies/rent_roll');
    return dispatch(notificationActions.showSuccess('renewalSuccessfullyGenerated'));
  };
}
